export default __webpack_public_path__ + "static/media/36I-102635_-15559_0.2a40ce9b.jpg";